<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
                    <div class="nav">
                        <ul>
                           <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>
        </div>
      </div>
    </div>
    <div class="war">
        <div class="content">
                 <div class="Calculator-main clearfix">
            <ul class="calculator_main_left">
                <li :class="database.color == 'D' && 'active'" @click="onChangeItem('color', 'D')"><button>D</button></li>
                <li :class="database.clarity == 'FL' && 'active'" @click="onChangeItem('clarity', 'FL')"><button>FL</button></li>
                <li :class="database.color == 'E' && 'active'" @click="onChangeItem('color', 'E')"><button>E</button></li>
                <li :class="database.clarity == 'IF' && 'active'" @click="onChangeItem('clarity', 'IF')"><button>IF</button></li>
                <li :class="database.color == 'F' && 'active'" @click="onChangeItem('color', 'F')"><button>F</button></li>
                <li :class="database.clarity == 'VVS1' && 'active'" @click="onChangeItem('clarity', 'VVS1')"><button>VVS1</button></li>
                <li :class="database.color == 'G' && 'active'" @click="onChangeItem('color', 'G')"><button>G</button></li>
                <li :class="database.clarity == 'VVS2' && 'active'" @click="onChangeItem('clarity', 'VVS2')"><button>VVS2</button></li>
                <li :class="database.color == 'H' && 'active'" @click="onChangeItem('color', 'H')"><button>H</button></li>
                <li :class="database.clarity == 'VS1' && 'active'" @click="onChangeItem('clarity', 'VS1')"><button>VS1</button></li>
                <li :class="database.color == 'I' && 'active'" @click="onChangeItem('color', 'I')"><button>I</button></li>
                <li :class="database.clarity == 'VS2' && 'active'" @click="onChangeItem('clarity', 'VS2')"><button>VS2</button></li>
                <li :class="database.color == 'J' && 'active'" @click="onChangeItem('color', 'J')"><button>J</button></li>
                <li :class="database.clarity == 'SI1' && 'active'" @click="onChangeItem('clarity', 'SI1')"><button>SI1</button></li>
                <li :class="database.color == 'K' && 'active'" @click="onChangeItem('color', 'K')"><button>K</button></li>
                <li :class="database.clarity == 'SI2' && 'active'" @click="onChangeItem('clarity', 'SI2')"><button>SI2</button></li>
                <li :class="database.color == 'L' && 'active'" @click="onChangeItem('color', 'L')"><button>L</button></li>
                <li :class="database.clarity == 'SI3' && 'active'" @click="onChangeItem('clarity', 'SI3')"><button>SI3</button></li>
                <li :class="database.color == 'M' && 'active'" @click="onChangeItem('color', 'M')"><button>M</button></li>
                <li :class="database.clarity == 'I1' && 'active'" @click="onChangeItem('clarity', 'I1')"><button>I1</button></li>
                <li :class="database.color == 'N' && 'active'" @click="onChangeItem('color', 'N')"><button>N</button></li>
                <li :class="database.clarity == 'I2' && 'active'" @click="onChangeItem('clarity', 'I2')"><button>I2</button></li>
            </ul>
            <div class="calculator_main_right">
                <div class="calculator_right_top">
                    <div class="calculator_top_btn clearfix">
                        <dd :class="database.shape == 'BR' && 'active'" @click="onChangeItem('shape', 'BR')">圆形</dd>
                        <dd :class="database.shape == 'PS' && 'active'" @click="onChangeItem('shape', 'PS')">异形</dd>
                    </div>
                    <ul class="calculator_top_info clearfix">
                        <li class="left">
                            <dd>重量（Ct）</dd>
                            <dt class="clearfix" @click="onChangeItem('onFocus', 'd_size', true)">
                                <span>{{database.d_size}}</span>
                                <span v-show="database.onFocus == 'd_size'" class="inputLine"></span>
                            </dt>
                        </li>
                        <li class="right">
                            <dd>国际报价</dd>
                            <dt class="clearfix">
                                <span>{{database.rap}}</span>
                            </dt>
                        </li>
                        <li class="left">
                            <dd>汇率</dd>
                            <dt class="clearfix" @click="onChangeItem('onFocus', 'dollar_rate', true)">
                                <span>{{database.dollar_rate}}</span>
                                <span v-show="database.onFocus == 'dollar_rate'" class="inputLine"></span>
                            </dt>
                        </li>
                        <li class="right">
                            <dd>折扣(%)</dd>
                            <dt class="disc clearfix" @click="onChangeItem('onFocus', 'disc', true)">
                                <span>{{database.disc}}</span>
                                <span v-show="database.onFocus == 'disc'" class="inputLine"></span>
                            </dt>
                        </li>
                    </ul>
                </div>
                <div class="calculator_right_middle clearfix">
                    <ul class="calculator_middle_left">
                        <li class="one">美元</li>
                        <li class="two">{{dollarPrice | eachFloat}}</li>
                        <li class="three">{{database.rap | eachFloat}}/Ct</li>
                    </ul>
                    <ul class="calculator_middle_right">
                        <li class="one">人民币</li>
                        <li class="two">{{rmbPrice | eachFloat}}</li>
                        <li class="three">{{rmbRap | eachFloat}}/Ct</li>
                    </ul>
                </div>
                <ul class="calculator_right_bottom clearfix">
                    <li @click="onChooseItem('1')"><button>1</button></li>
                    <li @click="onChooseItem('2')"><button>2</button></li>
                    <li @click="onChooseItem('3')"><button>3</button></li>
                    <li @click="onRemove" class="delete" style="border-right:none;"></li>
                    <li @click="onChooseItem('4')"><button>4</button></li>
                    <li @click="onChooseItem('5')"><button>5</button></li>
                    <li @click="onChooseItem('6')"><button>6</button></li>
                    <li @click="onChooseItem('0')" style="border-right:none;"><button>0</button></li>
                    <li @click="onChooseItem('7')" style="border-bottom:none;"><button>7</button></li>
                    <li @click="onChooseItem('8')" style="border-bottom:none;"><button>8</button></li>
                    <li @click="onChooseItem('9')" style="border-bottom:none;"><button>9</button></li>
                    <li @click="onChooseItem('.')" class="circle" style="border-right:none;border-bottom:none;"></li>
                </ul>
            </div>
        </div>
            </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
  </div>
</template>
<script>
    import Core from '@/until/core'
    export default {
        name: 'Calculator',
        data () {
            return {
                database: {
                    dollar_rate: 0,
                    shape: 'BR',
                    d_size: '',
                    color: 'D',
                    clarity: 'IF',
                    rap: 0,
                    disc: '',
                    onFocus: 'd_size'
                }
            }
        },
        components: {},
        watch: {
            webConfig (obj) {
                this.database.dollar_rate = obj.web_custommall_diamond_dollar_rate || 0
            }
        },
        computed: {
            webConfig () {
                return this.$store.state.config
            },
            rmbRap () {
                const rap = parseFloat(this.database.rap) || 0
                const dollar = parseFloat(this.database.dollar_rate) || 0
                return parseFloat(rap * dollar)
            },
            dollarPrice () {
                const rap = parseFloat(this.database.rap) || 0
                const size = parseFloat(this.database.d_size) || 0
                const disc = parseFloat(this.database.disc) || 0
                const price = size * rap * ((100 - disc) / 100)
                return price
            },
            rmbPrice () {
                const dollar = parseFloat(this.database.dollar_rate) || 0
                return this.dollarPrice * dollar
            }
        },
        filters: {
            eachFloat (val, num) {
                if (isNaN(parseFloat(val))) {
                    return '0.00'
                }
                return parseFloat(val).toFixed(num || 2)
            }
        },
        methods: {
             goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                        Core.onRemoveToken()
                        Core.goNext('StaffLogin', this.$route.params, true)
                    },
            goBack () {
                Core.goBack()
            },
            getRapPrice () {
                const that = this
                const size = parseFloat(that.database.d_size) || 0
                if (!size) {
                    return
                }
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('https://aped.happydiamond.cn/diamondCert/pc/ajaxDiamondQuotationOne.xhtml', that.database).then(result => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    const res = result.data || {}
                    if (parseInt(res.app_check_code, 10) === 0 && res.price) {
                        that.database.rap = res.price
                        return
                    }
                    layer.msg('系统繁忙，请稍后再试！', {icon: 0})
                    that.database.rap = 0
                })
            },
            onChangeItem (name, value, bool) {
                if (this.database[name] && this.database[name] === value) {
                    return
                }
                this.database[name] = value
                if (bool) {
                    return
                }
                this.getRapPrice()
            },
            onChooseItem (val) {
                this.database[this.database.onFocus] += val
                this.getRapPrice()
            },
            onRemove () {
                if (!this.database[this.database.onFocus]) {
                    return
                }
                const str = String(this.database[this.database.onFocus])
                this.database[this.database.onFocus] = str.substr(0, str.length - 1)
                if (!this.database[this.database.onFocus] && this.database.onFocus !== 'dollar_rate') {
                    this.database.rap = 0
                }
            }
        },
        mounted () {
            this.database.dollar_rate = this.webConfig.web_custommall_diamond_dollar_rate || 0
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../../node_modules/swiper/dist/css/swiper.min.css";
    @import "../../static/css/yellow.css";
    @import "../../static/css/font-awesome.css";
    .nav {
    height: 90px;
    }
    .header-ce {
    width: 1000px;
    }
    .header-ce ul li {
    float: left;
    line-height: 90px;
    width: 100px;
    text-align: center;
    }
    .Home-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;
    background-color: #fff;
    }
    .btn-hk {
    color: #fff;
    padding: 8px 16px;
    line-height: 100px;
    background: #f268a3;
    border-radius: 2px;
    font-size: 13px;
    }

    .modelBox {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.65);
    overflow: hidden;
    z-index: 999;
    }

    .model {
    position: absolute;
    width: 1000px;
    height: 500px;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: calc(50% - 350px);
    z-index: 9999;
    text-align: center;
    padding: 50px 0;
    }

    .closed {
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: absolute;
    right: 150px;
    top: 1200px;
    text-align: center;
    line-height: 22px;
    background: #e0b12f;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    }

    .timeer {
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100px;
    margin: auto;
    left: 0;
    right: 0;
    line-height: 40px;
    font-size: 14px;
    color: #ffeb3b;
    font-size: 30px;
    border-radius: 5px;
    }
    .Calculator-main{ position: absolute;  top: 1px; bottom: 0; z-index: 2; left:50%; margin-left:-700px;}
    ul.calculator_main_left{float:left;width:15%;height:100%;background-color: #fff;}
    ul.calculator_main_left li{float:left;width:50%;height:9.09%;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;}
    ul.calculator_main_left li button{width:100%;height:100%;border:none;font-size: 20px;background-color: #fff;}
    ul.calculator_main_left li.active button{background-color: #ff410f;color:#fff;}
    .calculator_main_right{float:left;width:85%;height:100%;position: relative;}
    .calculator_right_top{width:100%;height:38px;padding:0 20px;}
    .calculator_top_btn{width:45%;height:70px;border-bottom-left-radius: 6px;border-bottom-right-radius: 6px;overflow: hidden;background-color: #fff;margin:20px 0; }
    .calculator_top_btn dd{float:left;width:50%;height:100%;line-height: 70px;text-align: center;border-right:1px solid #edf1f2;font-size: 32px;}
    .calculator_top_btn dd.active{background-color: #ff410f;color:#fff;}
    ul.calculator_top_info{width:45%;}
    ul.calculator_top_info li{float:left;width:50%;height:110px;}
    ul.calculator_top_info li.left{padding-right:25px;}
    ul.calculator_top_info li.right{padding-left:25px;}
    ul.calculator_top_info li dd{width:100%;height:50px;line-height: 50px;font-size: 20px;}
    ul.calculator_top_info li dt{width:100%;height:64px;position: relative;background-color: #fff;padding:0 18px;}
    ul.calculator_top_info li dt.gray{background-color: #ccc;}
    ul.calculator_top_info li dt span{float:left;font-size: 24px;height:100%;line-height: 64px;}
    ul.calculator_top_info li dt span.inputLine{float:left;width:1px;height:34px;background-color: #000;margin-top:15px;}
    ul.calculator_top_info li dt input{width:100%;height:100%;border-radius: 0.04rem;font-size: 30px;border:1px solid #e5e5e4;padding:0 0.18rem;position: absolute;left:0;top:0;}
    ul.calculator_top_info li dt.disc:after{content:"";position: absolute;left:0;top:0;width:54px;height:94%;background: url(../../static/img/calculator_07.png) no-repeat center center;-webkit-background-size: 34px 34px;background-size: 34px 34px;}
    ul.calculator_top_info li dt.disc{padding-left:0.54rem;}
    .calculator_right_middle{width:55%;height:200px;padding:0 20px;}
    ul.calculator_middle_left{float:left;height:100%;padding: 0 25px;}
    ul.calculator_middle_right{float:left;height:100%;padding-left:25px;}
    ul.calculator_middle_left li.one,ul.calculator_middle_right li.one{width:100%;height:80px;line-height: 80px;font-size: 30px;}
    ul.calculator_middle_left li.two,ul.calculator_middle_right li.two{width:100%;height:72px;line-height: 72px;font-size: 30px;color:#141414;}
    ul.calculator_middle_left li.three,ul.calculator_middle_right li.three{width:100%;height:0.56rem;line-height: 0.56rem;font-size: 24px;color:#4c5860;}
    ul.calculator_right_bottom{position: absolute;right:20px;bottom:0;width:490px;height:390px;background-color: #fff;border:1px solid #e0e0e0;border-bottom:none;border-top-left-radius: 8px;border-top-right-radius: 8px;overflow: hidden;}
    ul.calculator_right_bottom li{float:left;width:25%;height:33.333%;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;}
    ul.calculator_right_bottom li button{width:100%;height:100%;border:none;font-size: 48px;background-color: #fff;}
    ul.calculator_right_bottom li.delete{background: url(../../static/img/calculator_11.png) no-repeat center center;-webkit-background-size: 0.53rem 0.31rem;background-size: 0.53rem 0.31rem;}
    ul.calculator_right_bottom li.circle{background: url(../../static/img/calculator_15.png) no-repeat center center;-webkit-background-size: 0.14rem 0.14rem;background-size: 0.14rem 0.14rem;}
</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue